(function(){
  var KEY = 'bb-popup-dismissed';
  document.addEventListener('DOMContentLoaded', function(){
    var burger = document.querySelector('.hdr__burger');
    var nav = document.querySelector('.hdr__nav');
    if (burger && nav) burger.addEventListener('click', function(){ nav.classList.toggle('is-open'); });

    var pop = document.querySelector('[data-popup]');
    if (!pop) return;
    var delay = parseInt(pop.getAttribute('data-delay') || '15', 10) * 1000;
    var open = function(){ pop.classList.add('is-open'); };
    var close = function(){ pop.classList.remove('is-open'); try { localStorage.setItem(KEY, '1'); } catch(e){} };

    if (pop.hasAttribute('data-posted')) { open(); }
    else {
      var seen = false;
      try { seen = localStorage.getItem(KEY) === '1'; } catch(e){}
      if (!seen) setTimeout(open, delay);
    }

    pop.querySelectorAll('[data-close]').forEach(function(b){ b.addEventListener('click', close); });
    pop.addEventListener('click', function(e){ if (e.target === pop) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    document.querySelectorAll('[data-open-popup]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); open(); });
    });

    var mode = 'text';
    var tabs = pop.querySelectorAll('.pop__tab');
    var fields = pop.querySelectorAll('.pop__field');
    var err = pop.querySelector('.pop__err');
    var fine = pop.querySelector('.pop__fine');
    var tel = pop.querySelector('input[type="tel"]');
    var mail = pop.querySelector('input[type="email"]');

    function setMode(next){
      mode = next;
      tabs.forEach(function(t){ t.setAttribute('aria-current', t.getAttribute('data-mode') === next ? 'true' : 'false'); });
      fields.forEach(function(f){
        var on = f.getAttribute('data-field') === next;
        f.hidden = !on;
        var input = f.querySelector('input');
        if (input) input.disabled = !on;
      });
      if (err) err.textContent = '';
      if (fine) fine.textContent = fine.getAttribute(next === 'text' ? 'data-fine-text' : 'data-fine-email') || '';
    }
    tabs.forEach(function(t){ t.addEventListener('click', function(){ setMode(t.getAttribute('data-mode')); }); });

    if (tel) tel.addEventListener('input', function(){
      var d = tel.value.replace(/\D/g,'').slice(0,10);
      tel.value = d.length > 6 ? '(' + d.slice(0,3) + ') ' + d.slice(3,6) + '-' + d.slice(6)
                : d.length > 3 ? '(' + d.slice(0,3) + ') ' + d.slice(3) : d;
      if (err) err.textContent = '';
    });
    if (mail) mail.addEventListener('input', function(){ if (err) err.textContent = ''; });

    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', function(e){
      var bad = mode === 'text'
        ? (!tel || tel.value.replace(/\D/g,'').length !== 10)
        : (!mail || !/.+@.+\..+/.test(mail.value));
      if (bad) {
        e.preventDefault();
        if (err) err.textContent = mode === 'text' ? 'Enter a 10-digit phone number.' : 'Enter a valid email address.';
      } else {
        try { localStorage.setItem(KEY, '1'); } catch(e2){}
      }
    });
  });
})();
